import React from 'react';
import { motion } from 'framer-motion';
import { useSubscription } from '../../hooks/useSubscription';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock, FiCreditCard, FiX } = FiIcons;

const TrialBanner = () => {
  const { userSubscription, dismissTrialBanner } = useSubscription();
  const navigate = useNavigate();

  if (!userSubscription || userSubscription.status !== 'trial' || userSubscription.dismissed) {
    return null;
  }

  const daysLeft = userSubscription.days_left;
  const isExpiringSoon = daysLeft <= 5;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      className={`relative ${
        isExpiringSoon 
          ? 'bg-gradient-to-r from-red-500 to-pink-600' 
          : 'bg-gradient-to-r from-blue-500 to-purple-600'
      } text-white p-4 shadow-lg`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
            isExpiringSoon ? 'bg-red-400' : 'bg-blue-400'
          } bg-opacity-30`}>
            <SafeIcon icon={FiClock} className="text-xl" />
          </div>
          <div>
            <h3 className="font-semibold">
              {isExpiringSoon 
                ? `Trial expires in ${daysLeft} day${daysLeft !== 1 ? 's' : ''}!` 
                : `${daysLeft} days left in your trial`
              }
            </h3>
            <p className="text-sm opacity-90">
              {isExpiringSoon 
                ? 'Upgrade now to continue using MedTracker without interruption'
                : 'Upgrade to premium for lifetime access - only AED 100!'
              }
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate('/subscription')}
            className="flex items-center space-x-2 bg-white text-gray-900 px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            <SafeIcon icon={FiCreditCard} />
            <span>Upgrade Now - AED 100</span>
          </motion.button>
          
          {!isExpiringSoon && (
            <button
              onClick={dismissTrialBanner}
              className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiX} />
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default TrialBanner;